import { generalLink, internalLinkReference } from "@pkg/sanity-utils/linkQueries";
import groq from "groq";

export const blockSolutionTilesFields = groq`
...,
tiles[] {
  ...,
  link {
    ...,
    link->{
      ${internalLinkReference}
    },
  },
}
`;